import React from "react";
import { ContainerWrapper } from "./styles";

interface ContainerProps {
  textAlign?: "left" | "center" | "right";
  maxWidth?: string;
  children: React.ReactNode | React.ReactNode[];
}

export const Container: React.FC<ContainerProps> = ({ children, ...rest }) => (
  <ContainerWrapper {...rest}>{children}</ContainerWrapper>
);
